<template>
  <div>
    <!-- Font & size -->
    <span class="ql-formats">
      <select class="ql-font" />
      <select class="ql-size" />
    </span>

    <!-- Basic formatting -->
    <span class="ql-formats">
      <button class="ql-bold" />
      <button class="ql-italic" />
      <button class="ql-underline" />
      <button class="ql-strike" />
    </span>

    <!-- Colors -->
    <span class="ql-formats">
      <select class="ql-color" />
      <select class="ql-background" />
    </span>

    <!-- Sub / superscript -->
    <span class="ql-formats">
      <button
        class="ql-script"
        value="sub"
      />
      <button
        class="ql-script"
        value="super"
      />
    </span>

    <!-- Headings -->
    <span class="ql-formats">
      <select class="ql-header">
        <option value="1" />
        <option value="2" />
        <option value="3" />
        <option value="4" />
        <option value="5" />
        <option value="6" />
        <option selected />
      </select>
    </span>

    <!-- Blocks -->
    <span class="ql-formats">
      <button class="ql-blockquote" />
      <button class="ql-code-block" />
    </span>

    <!-- Lists & indent -->
    <span class="ql-formats">
      <button
        class="ql-list"
        value="ordered"
      />
      <button
        class="ql-list"
        value="bullet"
      />
      <button
        class="ql-indent"
        value="-1"
      />
      <button
        class="ql-indent"
        value="+1"
      />
    </span>

    <!-- Alignment -->
    <span class="ql-formats">
      <select class="ql-align" />
    </span>

    <!-- Link & clear -->
    <span class="ql-formats">
      <button class="ql-link" />
      <button class="ql-clean" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'EditorToolbar',
}
</script>
